/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */
import type { CreateReportDtoStatus } from './createReportDtoStatus';
import type { CreateReportDtoAnimalType } from './createReportDtoAnimalType';
import type { CreateReportDtoSpecie } from './createReportDtoSpecie';
import type { CreateReportDtoWildType } from './createReportDtoWildType';
import type { CreateReportDtoSurveillanceType } from './createReportDtoSurveillanceType';
import type { CreateReportDtoHumanAffected } from './createReportDtoHumanAffected';
import type { CreateReportDtoDomesticAnimalAffected } from './createReportDtoDomesticAnimalAffected';
import type { CreateDiagnosticProcedureDto } from './createDiagnosticProcedureDto';

export interface CreateReportDto {
  /** Code of the report */
  code: string;
  /** Publication status of the report */
  status: CreateReportDtoStatus;
  /** Type of animal */
  animalType?: CreateReportDtoAnimalType;
  /** Species */
  specie?: CreateReportDtoSpecie;
  /** Wild type */
  wildType?: CreateReportDtoWildType;
  /** Latitude */
  latitude?: number;
  /** Longitude */
  longitude?: number;
  /** Inaccurate location flag */
  inaccurateLocation?: boolean;
  /** Detection date */
  detectionDate?: string;
  /** Surveillance type */
  surveillanceType?: CreateReportDtoSurveillanceType;
  /** Description */
  description?: string;
  /** Number of deaths */
  numberOfDeaths?: number;
  /** Number of sicks */
  numberOfSicks?: number;
  /** Population size */
  populationSize?: number;
  /** Human affected */
  humanAffected?: CreateReportDtoHumanAffected;
  /** Domestic animal affected */
  domesticAnimalAffected?: CreateReportDtoDomesticAnimalAffected;
  /** Known cause */
  knownCause?: boolean;
  /** Order */
  order?: string;
  /** Etiology type code */
  etiologyTypeCode?: string;
  /** Etiological agent code */
  etiologicalAgentCode?: string;
  /** Note for the version */
  versionNote?: string;
  /** Country code */
  countryCode: string;
  /** Diagnostic procedures */
  diagnosticProcedures?: CreateDiagnosticProcedureDto[];
}
